// extracted by mini-css-extract-plugin
export default {"billInfosContainer":"PrivateBillView_billInfosContainer__7tIKm","billDetails":"PrivateBillView_billDetails__CPEUf"};